export const LogType = Object.freeze({
    "Standard": 1,
    "Error": 2,
    "Completed": 3
})